import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const DataTableManageButton = ({item, rowIndex, rowActions}) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon/>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>

                {rowActions.map((itemAction, index) => (
                    <MenuItem key={index} onClick={() => {
                        itemAction.action && itemAction.action(item, rowIndex);
                        handleClose();
                    }}>
                        {itemAction.label}
                    </MenuItem>
                ))}

            </Menu>
        </>
    )

}

export default DataTableManageButton;
